





















import CoproprieteAccordion from "./CoproprieteAccordion.vue";
import CollapsiblePanel from "../../core/UI/CollapsiblePanel.vue";

export default {
    name: "SyndicAccordion",
    components: { CollapsiblePanel, CoproprieteAccordion },
    props: {
        syndic: String,
        groupedFactures: Object,
    },
    methods: {
        totalSyndic(syndicName) {
            const total = _.reduce(
                this.groupedFactures[syndicName],
                (total, relances) => total + this.totalCopropriete(relances),
                0
            );
            return _.round(total, 2).toFixed(2);
        },
        totalCopropriete(relances) {
            const total = _.reduce(
                relances,
                (total, relance) => total + relance.montant,
                0
            );
            return total;
        },
        onRelanceUpdated(updatedRelance) {
            // Propagate the event up to the parent component
            this.$emit("relance-updated", updatedRelance);
        },
    },
};
